import React from 'react';
import {
  Fastfood,
  LocalPizza,
  Restaurant,
  RestaurantMenu,
  Cake,
  LocalDrink,
  MenuBook
} from '@mui/icons-material';

export const getCategoryIcon = (categoryId: string) => {
  const iconProps = { fontSize: 'small' as const };

  switch (categoryId) {
    case 'burgers':
      return <Fastfood {...iconProps} />;
    case 'pizza':
      return <LocalPizza {...iconProps} />;
    case 'pasta':
      return <Restaurant {...iconProps} />;
    case 'salads':
      return <RestaurantMenu {...iconProps} />;
    case 'desserts':
      return <Cake {...iconProps} />;
    case 'drinks':
      return <LocalDrink {...iconProps} />;
    default:
      return <MenuBook {...iconProps} />;
  }
};

export const getAllCategoryIcon = () => <MenuBook fontSize="small" />;
